export default __webpack_public_path__ + "static/IN-8015_8mm_lense_night_softwareWDR-52d3bf9c8c580a482e8fbf9b2558a087.webp";